import classNames from 'clsx';
import React from 'react';

import type { GlobalFieldReference } from '@swf/cms';
import { CMSReference } from '@swf/cms';
import CloseIcon from '@swf/core/assets/icons/cross.svg';

import styles from './PanelItem.scss';

interface Props {
  body: GlobalFieldReference[];
  expanded: boolean;
  onClick: () => void;
  collapsedTitle?: string;
  expandedTitle?: string;
}

const PanelItem: React.FC<Props> = ({ body, collapsedTitle, expandedTitle, expanded, onClick }) =>
  body.length ? (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <button
          className={classNames(styles.cardTitleButton, { [styles.active]: expanded })}
          type="button"
          onClick={onClick}
        >
          <span className={styles.text}>{expanded ? expandedTitle : collapsedTitle}</span>
          <span className={styles.control}>
            <CloseIcon />
          </span>
        </button>
      </div>
      <div className={classNames(styles.collapse, { [styles.show]: expanded })}>
        <div className={styles.cardBody}>
          {body.map((item, itemIndex) => (
            <CMSReference key={itemIndex} {...item} />
          ))}
        </div>
      </div>
    </div>
  ) : null;

export default PanelItem;
